export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-14.7efd3faa.jpg";